// 보상 카드 지급 정산(골드가 아닌 카드): 저장으로 확정된 영수증을 보고 장비 장부에 넣는다. flow.settleCardLoots가 부르고, 시험은 이 함수를 직접 부른다.
// 이중 지급이 없는 이유: ① 지급 연산 id가 `cd:<영수증 id>`라 장부가 같은 연산을 거른다 ② 장부 저장이 확인된 뒤에만 영수증에 cardGranted를 적는다
// (장부의 최근 연산 기억 APPLIED_CAP개가 넘어가도 같은 영수증을 다시 지급하지 않는다) ②b 표시를 적기 전에 탭이 닫혀도 장부가 `cd:` 연산 id를 일반 연산과 따로 기억한다(trimApplied) ③ 선택은 저장으로 확정된 값만 보므로 두 탭이 다른 카드를 골라도 이긴 쪽만 지급된다.
import { cardGrantOp } from '../shared/content/cardReward';
import type { GearStore } from './gear';
import type { SaveStore } from './save';

/** 지급 대기 영수증을 모두 정산한다. 장부 저장이 실패했거나 지급 완료 표시 저장이 아직 확인되지 않았으면 false(다음 주기에 다시 시도) */
export function settleCardLoots(save: SaveStore, gear: GearStore): boolean {
  let ok = true;
  for (const r of save.ungrantedCards()) {
    const desc = r.cardLoot?.[r.pickedCard] ?? '';
    const op = cardGrantOp(r.id, desc);
    if (op) {
      const res = gear.submit(op);
      // ok·auto_salvaged(가방이 가득 차 바로 정리)·duplicate(이미 들어감)면 저장 확인으로 넘어간다. 그 밖(알 수 없는 정의 등)은 다시 해도 같아 지급 완료로 닫는다
      if ((res.code === 'ok' || res.code === 'auto_salvaged' || res.code === 'duplicate') && !gear.flush(true)) { ok = false; continue; }
    }
    save.markCardGranted(r.id);
  }
  // 지급 완료 표시가 아직 저장으로 확정되지 않았으면 끝난 게 아니다: 재시도 주기를 유지한다(P3-1). 다만 탭이 닫혀도 장부가 `cd:` 연산을 따로 오래 기억해(trimApplied) 다시 지급하지 않는다
  return ok && !save.hasUnconfirmedCardGrant();
}
